module.exports = __webpack_public_path__ + "img/button_apply.a3b5839d.png";